import clsx from 'clsx';
import RadioCard from './RadioCard';

export interface RadioCardOption<T extends string = string> {
  value: T;
  icon: React.ReactNode;
  title: string;
  subtitle?: string;
}

export interface RadioCardGroupProps<T extends string = string> {
  options: RadioCardOption<T>[];
  value: T | '';
  onChange: (value: T) => void;
  disabled?: boolean;
  className?: string;
}

/**
 * Lays out a small set of RadioCard options in the 2-up grid used across
 * the app (e.g. Pool Style, Sanitation Type).
 */
const RadioCardGroup = <T extends string = string>({
  options,
  value,
  onChange,
  disabled,
  className,
}: RadioCardGroupProps<T>) => (
  <div className={clsx('grid grid-cols-1 gap-3 sm:grid-cols-2', className)}>
    {options.map((option) => (
      <RadioCard
        key={option.value}
        icon={option.icon}
        title={option.title}
        subtitle={option.subtitle}
        active={value === option.value}
        disabled={disabled}
        onSelect={() => onChange(option.value)}
      />
    ))}
  </div>
);

export default RadioCardGroup;
